import { Stop } from 'generated/mos/org/getty/audio'
import { TranslatableLinkableStringValue, TranslatableMediaValue, TranslatableStringValue } from 'generated/mos/translatable'

import { Schema } from 'helpers/schema'
import {
  createLinkableMediaValue,
  createLinkableStringValue,
  getLinkableValue,
  createLinkablePlacementValue,
} from 'helpers/linkables'
import {
  createTranslatableLinkableStringValue,
  createTranslatableMediaValue,
  getTranslatableValue,
  getTranslatableLinkableValue,
  setTranslatableLinkableValue,
  setTranslatableValue,
  createTranslatableStringValue,
} from 'helpers/translatables'

const isNonEmpty = (value: any) => {
  if (typeof value === 'string' && (!value || !value.trim().length) || typeof value === 'object' && !Object.keys(value).length) {
    return false
  }

  return value
}

export const stopSchema: Schema<Stop.Entity> = {
  title: {
    read: (value, language) => getTranslatableLinkableValue(value, language),
    write: (value, existingValue, language) => isNonEmpty(value) ? setTranslatableLinkableValue(
      createTranslatableLinkableStringValue(value as any, language),
      existingValue ?
        existingValue as TranslatableLinkableStringValue.Entity :
        TranslatableLinkableStringValue.defaults,
    ) as any as TranslatableLinkableStringValue.Entity : undefined,
  },
  artworkName: {
    read: (value, language) => value ? getTranslatableLinkableValue(value, language): undefined,
    write: (value, existingValue, language) => isNonEmpty(value) ? setTranslatableLinkableValue(
      createTranslatableLinkableStringValue(value as any, language),
      existingValue ?
        existingValue as TranslatableLinkableStringValue.Entity :
        TranslatableLinkableStringValue.defaults,
    ) as any as TranslatableLinkableStringValue.Entity : undefined,
  },
  producedBy: {
    read: (value, language) => getTranslatableLinkableValue(value, language),
    write: (value, existingValue, language) => isNonEmpty(value) ? setTranslatableLinkableValue(
      createTranslatableLinkableStringValue(value as any, language),
      existingValue ?
        existingValue as TranslatableLinkableStringValue.Entity :
        TranslatableLinkableStringValue.defaults,
    ) as any as TranslatableLinkableStringValue.Entity : undefined,
  },
  placeCreated: {
    read: (value, language) => getTranslatableLinkableValue(value, language),
    write: (value, existingValue, language) => isNonEmpty(value) ? setTranslatableLinkableValue(
      createTranslatableLinkableStringValue(value as any, language),
      existingValue ?
        existingValue as TranslatableLinkableStringValue.Entity :
        TranslatableLinkableStringValue.defaults,
    ) as any as TranslatableLinkableStringValue.Entity : undefined,
  },
  dateCreated: {
    read: (value, language) => getTranslatableLinkableValue(value, language),
    write: (value, existingValue, language) => isNonEmpty(value) ? setTranslatableLinkableValue(
      createTranslatableLinkableStringValue(value as any, language),
      existingValue ?
        existingValue as TranslatableLinkableStringValue.Entity :
        TranslatableLinkableStringValue.defaults,
    ) as any as TranslatableLinkableStringValue.Entity : undefined,
  },
  materials: {
    read: (value, language) => getTranslatableLinkableValue(value, language),
    write: (value, existingValue, language) => isNonEmpty(value) ? setTranslatableLinkableValue(
      createTranslatableLinkableStringValue(value as any, language),
      existingValue ?
        existingValue as TranslatableLinkableStringValue.Entity :
        TranslatableLinkableStringValue.defaults,
    ) as any as TranslatableLinkableStringValue.Entity : undefined,
  },
  creditLine: {
    read: (value, language) => getTranslatableLinkableValue(value, language),
    write: (value, existingValue, language) => isNonEmpty(value) ? setTranslatableLinkableValue(
      createTranslatableLinkableStringValue(value as any, language),
      existingValue ?
        existingValue as TranslatableLinkableStringValue.Entity :
        TranslatableLinkableStringValue.defaults,
    ) as any as TranslatableLinkableStringValue.Entity : undefined,
  },
  image: {
    read: value => getLinkableValue(value),
    write: value => isNonEmpty(value) ? createLinkableMediaValue(value as any) : undefined,
  },
  imageCopyright: {
    read: value => getLinkableValue(value),
    write: value => isNonEmpty(value) ? createLinkableStringValue(value as any) : undefined,
  },
  publicImageTitle: {
    read: (value, language) => getTranslatableValue(value, language) as any,
    write: (value, existingValue, language) => isNonEmpty(value) ? setTranslatableValue(
      createTranslatableStringValue(value as any, language),
        existingValue ?
          existingValue as TranslatableStringValue.Entity :
          TranslatableStringValue.defaults,
      ) as any as TranslatableStringValue.Entity : undefined,
  },
  objectDescription: {
    read: (value, language) => getTranslatableLinkableValue(value, language),
    write: (value, existingValue, language) => isNonEmpty(value) ? setTranslatableLinkableValue(
      createTranslatableLinkableStringValue(value as any, language),
      existingValue ?
        existingValue as TranslatableLinkableStringValue.Entity :
        TranslatableLinkableStringValue.defaults,
    ) as any as TranslatableLinkableStringValue.Entity : undefined,
  },
  objectCopyright: {
    read: value => getLinkableValue(value),
    write: value => isNonEmpty(value) ? createLinkableStringValue(value as any) : undefined,
  },
  audio: {
    read: (value, language) => getTranslatableValue(value, language),
    write: (value, existingValue, language) => isNonEmpty(value) ? setTranslatableValue(
      createTranslatableMediaValue(value as any, language),
      existingValue ?
        existingValue as TranslatableMediaValue.Entity :
        TranslatableMediaValue.defaults,
    ) as any as TranslatableMediaValue.Entity : undefined,
  },
  placement: {
    read: value => getLinkableValue(value),
    write: value => isNonEmpty(value) ? createLinkablePlacementValue(value as any) : undefined,
  }
}
